import(/* webpackMode: "eager" */ "/codebuild/output/src1770170836/src/ui-directo/apps/prospects/src/app/error.tsx");
